export enum AssetPreparationStatus {
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  REJECTED = 'REJECTED',
  // TODO(mara-cashlink): use or remove ERROR, adjust to api ManagedAssetPreparationStatusEnum
  // ERROR = "ERROR",
}
